import { Button, CustomDatePicker, Input } from '@ui';
import moment from 'moment';
import React, { FC, useState } from 'react';
import { Range } from '@app/components/ui/easy-filter/types';

type DateIntervalKeep = {
  start: string | null;
  startTime: string | null;
  endTime: string | null;
  end: string | null;
};

type AnalyticsMetricRecalcRangePropType = {
  actionOnSuccess(date: Range): void;
  onClose(): void;
};

const AnalyticsMetricRecalcRange: FC<AnalyticsMetricRecalcRangePropType> = (props) => {
  const { onClose, actionOnSuccess } = props;

  // const fullDateFromPropsStart = defaultDates?.start?.split(' ');
  // const fullDateFromPropsEnd = defaultDates?.end?.split(' ');

  const DEFAULT_TIME_START = '00:00';
  const DEFAULT_TIME_END = '23:59';
  const DEFAULT_DATE = moment().format('DD.MM.yyyy');

  const [dateInterval, setDateInterval] = useState<DateIntervalKeep>({
    start: DEFAULT_DATE,
    end: DEFAULT_DATE,
    endTime: DEFAULT_TIME_START,
    startTime: DEFAULT_TIME_END,
  });

  function handlerChangePicker({
    date,
    type,
  }: {
    date: Date | null | string;
    type: 'start' | 'end' | 'startTime' | 'endTime';
  }) {
    setDateInterval((prevState) => ({
      ...prevState,
      [type]: type === 'end' || type === 'start' ? date : date,
    }));
  }

  function handleApprove() {
    const date: Range['range'] = {
      type: 'r',
      parameters: [
        {
          value: `${moment(dateInterval.start, 'DD.MM.yyyy').format('YYYY-MM-DD')} ${
            dateInterval.startTime
          }:00`,
          condition: '>=',
        },
        {
          value: `${moment(dateInterval.end, 'DD.MM.yyyy').format('YYYY-MM-DD')} ${
            dateInterval.endTime
          }:00`,
          condition: '<=',
        },
      ],
    };
    try {
      actionOnSuccess(date as unknown as Range);
    } finally {
      onClose();
    }
  }

  return (
    <div className="">
      <div className="inline-flex items-center h-[150px]">
        <div className="mr-[10px]">от</div>
        <CustomDatePicker
          selected={moment(dateInterval.start, 'DD.MM.yyyy').toDate()}
          onChange={(date) => handlerChangePicker({ date, type: 'start' })}
          maxDate={moment(dateInterval.end, 'DD.MM.yyyy').toDate()}
          minDate={moment(dateInterval.end, 'DD.MM.yyyy').subtract(364, 'days').toDate()}
        />

        <div className="w-[110px] ml-[11px]">
          <Input
            mask="99:99"
            name="timeStart"
            icon="ClockIcon"
            defaultValue={dateInterval.startTime || DEFAULT_TIME_START}
            onChange={(event) =>
              handlerChangePicker({ date: event.target.value, type: 'startTime' })
            }
          />
        </div>
        <div className="mr-[10px]  ml-[23px]">до</div>
        <CustomDatePicker
          selected={moment(dateInterval.end, 'DD.MM.yyyy').toDate()}
          onChange={(date) => handlerChangePicker({ date, type: 'end' })}
          maxDate={moment(dateInterval.start, 'DD.MM.yyyy').subtract(-364, 'days').toDate()}
          minDate={moment(dateInterval.start, 'DD.MM.yyyy').toDate()}
        />
        <div className="w-[110px] ml-[11px]">
          <Input
            mask="99:99"
            defaultValue={dateInterval.endTime || DEFAULT_TIME_END}
            name="timeEnd"
            onChange={(event) => handlerChangePicker({ date: event.target.value, type: 'endTime' })}
            icon="ClockIcon"
          />
        </div>
      </div>
      <div className="pt-[10px] pb-[20px]">
        <Button onClick={handleApprove} label="Применить" />
        <Button fill="linked" onClick={onClose} label="Отменить" />
      </div>
    </div>
  );
};

export default AnalyticsMetricRecalcRange;
